(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/primary-onboarding/assets/javascripts/onboarding-state.js') >= 0) return;  svs.modules.push('/templates/primary-onboarding/assets/javascripts/onboarding-state.js');
"use strict";

var _svs$onboarding;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$components$lbUti = svs.components.lbUtils.onboarding.events,
  AddTooltipEvent = _svs$components$lbUti.AddTooltipEvent,
  DeleteTooltipEvent = _svs$components$lbUti.DeleteTooltipEvent;
const createToolTipEventHandler = svs.components.lbUtils.onboarding.events.eventHandlers.createToolTipEventHandler;
const TooltipEventType = svs.components.lbUtils.onboarding.events.constants.TooltipEventType;
const onboardingDomain = svs.components.lbUtils.onboarding.utils.onboardingDomain;
const _svs$templates$primar = svs.templates.primaryOnboarding.constants,
  HintVisibility = _svs$templates$primar.HintVisibility,
  TemplateSelectors = _svs$templates$primar.TemplateSelectors;
const _svs$templates$primar2 = svs.templates.primaryOnboarding.target,
  addTargetOfInterest = _svs$templates$primar2.addTargetOfInterest,
  removeTargetOfInteresetByKey = _svs$templates$primar2.removeTargetOfInteresetByKey,
  hasTargetOfInterest = _svs$templates$primar2.hasTargetOfInterest,
  getInterestsSize = _svs$templates$primar2.getInterestsSize;
const _svs$templates$primar3 = svs.templates.primaryOnboarding.onboardingInfo,
  getHintFromKey = _svs$templates$primar3.getHintFromKey,
  addTargetRef = _svs$templates$primar3.addTargetRef,
  forEachOnboardingInfo = _svs$templates$primar3.forEachOnboardingInfo,
  findOnboardingInfo = _svs$templates$primar3.findOnboardingInfo;
const _svs$templates$primar4 = svs.templates.primaryOnboarding.hintItem,
  addNewHint = _svs$templates$primar4.addNewHint,
  updateHintWithChanges = _svs$templates$primar4.updateHintWithChanges,
  registerHintHooks = _svs$templates$primar4.registerHintHooks;
const _svs$templates$primar5 = svs.templates.primaryOnboarding.mutationObserver,
  addKnownTarget = _svs$templates$primar5.addKnownTarget,
  addUnknownTarget = _svs$templates$primar5.addUnknownTarget,
  connectMutationObserver = _svs$templates$primar5.connectMutationObserver,
  disconnectMutationObserver = _svs$templates$primar5.disconnectMutationObserver;
const _svs$templates$primar6 = svs.templates.primaryOnboarding.intersectionObserver,
  removeIntersectionObserver = _svs$templates$primar6.removeIntersectionObserver,
  disconnectIntersectionObserver = _svs$templates$primar6.disconnectIntersectionObserver;
const logger = svs.components.lbUtils.onboarding.log;
const _ref = ((_svs$onboarding = svs.onboarding) === null || _svs$onboarding === void 0 || (_svs$onboarding = _svs$onboarding.contextualOnboarding) === null || _svs$onboarding === void 0 ? void 0 : _svs$onboarding.data) || {
    hints: {}
  },
  hints = _ref.hints;

const hintValues = Object.values(hints);
const onboardingContentEl = document.querySelector(TemplateSelectors.TemplateContent);
if (onboardingContentEl && hintValues.length > 0) {
  const _onboardingDomain = onboardingDomain(svs.core.data.module, svs.core.data.baseUrl),
    setCount = _onboardingDomain.setCount;
  const _createToolTipEventHa = createToolTipEventHandler(),
    dispatchTooltipEvent = _createToolTipEventHa.dispatchEvent;
  const _createToolTipEventHa2 = createToolTipEventHandler(),
    addTooltipEventListener = _createToolTipEventHa2.addEventListener;
  const closeDownObservers = () => {
    logger.debug('Closing down observers');
    disconnectIntersectionObserver();
    disconnectMutationObserver();
  };
  const removeTargetOfInterest = key => {
    const hint = getHintFromKey(key);
    removeTargetOfInteresetByKey(key);
    if (!hasTargetOfInterest(hint.target)) {
      logger.debug("Target is boring ".concat(hint.target, ". Closing down observers"));
      removeIntersectionObserver(hint.targetEl, hint);
    }
    if (getInterestsSize() === 0) {
      logger.debug('Interest reached 0. Closing down observers');
      closeDownObservers();
    } else {
      logger.debug("Interest is at ".concat(getInterestsSize()));
    }
  };
  const mountHintItem = hintItem => {
    addTargetRef(hintItem.target, hintItem.key);
    addTargetOfInterest(hintItem.target, hintItem.key);
    const targetEl = onboardingContentEl.querySelector(hintItem.target);
    if (targetEl) {
      addKnownTarget(targetEl, hintItem.target);
    } else {
      addUnknownTarget(hintItem.target);
    }
  };
  const addToolTip = hint => {
    if (!hint.hasTriggered && !hint.isBlocked) {
      logger.debug("Dispatching tooltip add event! ".concat(hint.key));
      dispatchTooltipEvent(new AddTooltipEvent(_objectSpread(_objectSpread({}, hint), {}, {
        ref: hint.key
      })));
    } else if (hint.isBlocked) {
      logger.debug("Cant add tooltip because its blocked! ".concat(hint.dependency, " -> ").concat(hint.key));
    } else if (hint.hasTriggered) {
      logger.debug("Cant add tooltip because its already triggerd! ".concat(hint.key));
    }
  };
  const removeToolTip = hint => {
    dispatchTooltipEvent(new DeleteTooltipEvent(hint));
  };
  registerHintHooks({
    visibility: (_oldValue, newValue, _oldHint, newHint) => {
      if (newValue === HintVisibility.Visible) {
        addToolTip(newHint);
      } else if (newValue === HintVisibility.None) {
        removeToolTip(newHint);
        removeTargetOfInterest(newHint.key);
      }
    },
    count: (_oldValue, newValue, _oldHint, newHint) => {
      if (newValue && newHint.displaycount > 0) {
        logger.debug('Count changed!', newValue);
        setCount(newHint.key, newValue);
      }
    },
    isBlocked: (oldValue, newValue, _oldHint, newHint) => {
      if (oldValue && !newValue && newHint.visibility === HintVisibility.Visible) {
        addToolTip(newHint);
      }
    }
  });
  hintValues.forEach(hint => {
    addNewHint(hint);
  });
  forEachOnboardingInfo(hintItem => {
    if (hintItem.dependency && hintItem.dependency.length > 0) {
      const _ref2 = findOnboardingInfo(_ref4 => {
          let _ref5 = _slicedToArray(_ref4, 2),
            h = _ref5[1];
          return h.key === hintItem.dependency;
        }) || [undefined, undefined],
        _ref3 = _slicedToArray(_ref2, 2),
        dependencyHint = _ref3[1];
      if (!dependencyHint || dependencyHint.hasTriggered) {
        hintItem.dependency = undefined;
        hintItem.isBlocked = false;
      } else {
        dependencyHint.child = hintItem.key;
        hintItem.isBlocked = true;
      }
    }
    if (!hintItem.hasTriggered) {
      mountHintItem(hintItem);
    }
  });
  addTooltipEventListener(TooltipEventType.Created, e => {
    logger.debug('Tooltip created', e.detail.target);
    const hint = getHintFromKey(e.detail.ref);
    updateHintWithChanges(hint, {
      tooltipEl: e.detail.tooltip,
      hasTriggered: true
    });
  });
  addTooltipEventListener(TooltipEventType.Removed, e => {
    logger.debug('Tooltip removed', e.detail.target);
    const hint = getHintFromKey(e.detail.ref);
    removeTargetOfInterest(hint.key);
    let count = hint.count;
    if (hint.displaycount > 0 && hint.count < hint.displaycount) {
      count++;
    }
    updateHintWithChanges(hint, {
      tooltipEl: null,
      count
    });
    if (hint.child && hint.child.length > 0) {
      const childHint = getHintFromKey(hint.child);
      updateHintWithChanges(childHint, {
        isBlocked: false
      });
    }
  });
  window.addEventListener('beforeunload', () => {
    closeDownObservers();
  });
  const mutationObserverOpt = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['id', 'class']
  };
  connectMutationObserver(onboardingContentEl, mutationObserverOpt);
}

 })(window);